import React from 'react';
import { motion } from 'framer-motion';
import { Download, Settings, Play } from 'lucide-react';
const steps = [{
  icon: <Download className="w-8 h-8 text-brand-orange" data-id="element-139" />,
  title: 'DESCARGAS',
  description: 'Recibes el PDF en tu correo inmediatamente después de la compra.'
}, {
  icon: <Settings className="w-8 h-8 text-brand-orange" data-id="element-140" />,
  title: 'AJUSTAS',
  description: 'Eliges tus "herramientas" en casa siguiendo nuestra guía de inventario.'
}, {
  icon: <Play className="w-8 h-8 text-brand-orange" data-id="element-141" />,
  title: 'ENTRENAS',
  description: 'Sigues el Plan de 21 días y empiezas a ver cambios en tu fuerza y energía desde la primera semana.'
}];
export function HowItWorksSection() {
  return <section className="py-20 bg-brand-darker" data-id="element-142">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-143">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-16" data-id="element-144">
          <h2 className="text-4xl md:text-5xl uppercase" data-id="element-145">
            CÓMO <span className="text-brand-orange" data-id="element-146">FUNCIONA</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-147">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-zinc-800" data-id="element-148" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative text-center" data-id="element-149">
              <div className="bg-zinc-950 w-24 h-24 mx-auto rounded-full flex items-center justify-center border-4 border-zinc-900 relative z-10 mb-6 shadow-[0_0_30px_rgba(255,107,26,0.1)]" data-id="element-150">
                {step.icon}
                <div className="absolute -top-2 -right-2 bg-brand-orange text-white w-8 h-8 rounded-full flex items-center justify-center font-display text-lg" data-id="element-151">
                  {index + 1}
                </div>
              </div>
              <h3 className="text-2xl mb-4 uppercase tracking-wide" data-id="element-152">
                {step.title}
              </h3>
              <p className="text-zinc-400 text-lg leading-relaxed px-4" data-id="element-153">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}